import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../app/shared/services/mdb-modal-stub.service';
import { ToolsConstant } from '../shared/models/constants';
import { Enums } from '../shared/models/enums';
import { CellRendererElementSubTypes } from '../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class OrganizationService {
    OrgCols: Array<TableColumn> = [
        {
            field: '',
            header: '',
            hideColumnHeaderCheckBox: true,
            columnCheckBox: true,
            sort: false,
            pinned: false
        },

        {
            field: 'legalCompanyName',
            header: 'Legal Name Of Organization',
            sort: true,
            pinned: false,
            sortName: 'legalCompanyName',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'organisationID',
            header: 'Employee Organization ID (EOID)',
            sort: true,
            pinned: false,
            sortName: 'organisationID',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'taxID',
            header: 'Tax ID of Organization',
            sort: true,
            pinned: false,
            sortName: 'taxID',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'type',
            header: 'Organization Type',
            sort: true,
            pinned: false,
            sortName: 'type',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: 'All' },
                    { label: 'Agriculture, Forestry, Fishing & Hunting', value: 'Agriculture, Forestry, Fishing & Hunting' },
                    { label: 'Manufacturing', value: 'Manufacturing' },
                    { label: 'Mining', value: 'Manufacturing' },
                    { label: 'Utilities', value: 'Utilities' },
                    { label: 'Construction', value: 'Construction' },
                    { label: 'Transportation and Warehousing', value: 'Transportation and Warehousing' },
                    { label: 'Information', value: 'Information' },
                    { label: 'Wholesale Trade', value: 'Wholesale Trade' },
                    { label: 'Retail Trade', value: 'Retail Trade' },
                    { label: 'Finance and Insurance', value: 'Finance and Insurance' },
                    { label: 'Real Estate and Rental and Leasing', value: 'Real Estate and Rental and Leasing' },
                    { label: 'Health Care and Social Assistance', value: 'Health Care and Social Assistance' },
                    { label: 'Professional, Scientific and Technical Services', value: 'Professional, Scientific and Technical Services' },
                    { label: 'Management of Companies and Enterprises', value: 'Management of Companies and Enterprises' },
                    { label: 'Administrative and Support and Waste Management', value: 'Administrative and Support and Waste Management' },
                    { label: 'Educational Services', value: 'Educational Services' },
                    { label: 'Arts, Entertainment and Recreation', value: 'Arts, Entertainment and Recreation' },
                    { label: 'Accomodation and Food Services', value: 'Accomodation and Food Services' },
                    { label: 'Central Administrative Office Activity', value: 'Central Administrative Office Activity' },
                    { label: 'Other Services (except Public Administration)', value: 'Other Services(except Public Administration)' },
                ]
            },
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            pinned: false,
            sortName: 'country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'state',
            header: 'State/ Province',
            sort: true,
            pinned: false,
            sortName: 'state',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            pinned: false,
            sortName: 'city',
            filter: { type: FilterTypes.text }
        }
    ];
    MembersCols: Array<TableColumn> = [
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            pinned: false,
            sortName: 'firstName',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            pinned: false,
            sortName: 'lastName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'role',
            header: 'Role',
            sort: true,
            pinned: false,
            sortName: 'role',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'email',
            header: 'Email',
            sort: true,
            pinned: false,
            sortName: 'email',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'accessSince',
            header: 'Access Since',
            sort: true,
            pinned: false,
            sortName: 'accessSince',
            //filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        
        {
            field: 'canDeleted',
            header: 'Remove',
            isEnable: 'canDeleted',
            displayName: ' ',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDeleteOrgMember',
                elementsubType: CellRendererElementSubTypes.delete,
            }
        },

    ];
    orgProjectCols: Array<TableColumn> = [
        {
            field: 'subprojectName',
            header: 'Subproject Name',
            translationKey: 'subprojectName',
            sort: true,
            pinned: false,
            sortName: 'subprojectName',
            filter: { type: FilterTypes.text },
            //cellRenderer: {
            //    type: CellRendererTypes.event,
            //    elementType: CellRendererElementTypes.anchor,
            //    eventName: 'onSubprojectNameclick'
            //}
        },
        {
            field: 'projectName',
            header: 'Project Name',
            translationKey: 'ProjName',
            sort: true,
            pinned: false,
            sortName: 'ProjectName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'auditorName',
            header: 'Auditor',
            translationKey: 'auditorName',
            sort: true,
            sortName: 'AuditorName',
            filter: { type: FilterTypes.text },
            //cellRenderer: {
            //    type: CellRendererTypes.html
            //    // renderHtml: this.caAuditorCellRenderer
            //}
        },
        
        {
            field: 'certifierName',
            header: 'Certifier',
            translationKey: 'ProjectCertifier',
            sort: true,
            sortName: 'certifierName',
            filter: { type: FilterTypes.text }
        },
       
        {
            field: 'buildingType',
            header: 'Building Type',
            translationKey: 'BuildingType',
            sort: true,
            sortName: 'BuildingType',
            filter: {
                type: FilterTypes.select, selectOptions: ToolsConstant.buildingType
            }
        },
        {
            field: 'country',
            header: 'Country',
            translationKey: 'country',
            sort: true,
            sortName: 'country',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'versionNumber',
            header: 'Version Number',
            translationKey: 'versionNumber',
            sort: true,
            sortName: 'versionNumber',
            filter: {
                type: FilterTypes.select, selectOptions: ToolsConstant.versionNumbers
            },
        },

        {
            field: 'fileNumber',
            header: 'File Number',
            translationKey: 'FileNumber',
            sortName: 'FileNo',
            sort: false,
            filter: { type: FilterTypes.text }
        },

        {
            field: 'projectNumber',
            header: 'Project Number',
            translationKey: 'projectNumber',
            sortName: 'projectNumber',
            sort: false,
            filter: { type: FilterTypes.text }
        },

              
        {
            field: 'shareWithInvestor',
            header: 'Share with Bank(s)',
            translationKey: 'shareWithInvestor',
            sort: true,
            sortName: 'shareWithInvestor',
            filter: {
                type: FilterTypes.select, selectOptions: ToolsConstant.shareWithBanks
            },
        },
        
        {
            field: 'energy',
            header: 'Energy',
            translationKey: 'Energy',
            sortName: 'Energy',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.savingsCellRenderer
            //}
        },
        {
            field: 'water',
            header: 'Water',
            translationKey: 'Water',
            sortName: 'Water',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.savingsCellRenderer
            //}
        },
        {
            field: 'material',
            header: 'Material',
            translationKey: 'Material',
            sortName: 'Material',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.savingsCellRenderer
            //}
        },
        {
            field: 'energySavingsPerYear',
            header: 'Energy Savings(MWh/Year)',
            translationKey: 'EnergySavings',
            sortName: 'EnergySavings',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'waterSavingsPerYear',
            header: 'Water Savings(m³/Year)',
            translationKey: 'WaterSavings',
            sortName: 'WaterSavings',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'embodiedEnergyMaterialSavings',
            header: 'Embodied Energy in Materials Savings(GJ)',
            translationKey: 'EmbodiedEnergy',
            sortName: 'EmbodiedEnergy',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'embodiedCarbonMaterialSavings',
            header: 'Embodied Carbon in Materials Savings(GJ)',
            translationKey: 'EmbodiedCarbon',
            sortName: 'EmbodiedCarbon',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'cO2SavingsPerYear',
            header: 'CO2 Savings(tCO2/Year)',
            translationKey: 'CO2Savings',
            sortName: 'CO2Savings',
            filter: { type: FilterTypes.text },
            sort: true,
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'totalProjectFloorArea',
            header: 'Total Project Floor Area(m²)',
            translationKey: 'TotalProjectFloorArea',
            filter: { type: FilterTypes.text },
            sort: true,
            sortName: 'TotalProjectFloorArea',
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'floorSpaceCertified',
            header: 'Total Subproject Floor Area(m²)',
            translationKey: 'FloorSpaceCertified',
            filter: { type: FilterTypes.text },
            sort: true,
            sortName: 'FloorSpaceCertified',
            //cellRenderer: {
            //    type: CellRendererTypes.html,
            //    renderHtml: this.fixedTo2Decimal
            //}
        },
        {
            field: 'totalBuildingConstructionCost',
            header: 'Total building construction cost',
            translationKey: 'TotalBuildingConstructionCost',
            sort: true,
            sortName: 'TotalBuildingConstructionCost',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'incrementalCost',
            header: 'Incremental cost',
            translationKey: 'Incrementalcost',
            sort: true,
            sortName: 'IncrementalCost',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'currencySymbol',
            header: 'Local currency unit',
            translationKey: 'LlocalCurrencyUnit',
            sort: true,
            sortName: 'CurrencySymbol',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'increaseinCost',
            header: 'Increase in cost (%)',
            translationKey: 'IncreaseInCost',
            sort: true,
            sortName: 'IncreaseinCost',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'paybackinYears',
            header: 'Payback in years',
            translationKey: 'PaybackInYears',
            sort: true,
            sortName: 'PaybackinYears',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'createdDate',
            header: 'Created Date',
            translationKey: 'CreatedDate',
            sort: true,
            sortName: 'CreatedDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        
        {
            field: 'lastActivity',
            header: 'Last Activity',
            translationKey: 'LastActive',
            sort: true,
            sortName: 'LastActivity',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastOpened',
            header: 'Last Opened',
            translationKey: 'LastOpenedDate',
            sort: true,
            sortName: 'LastOpened',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        }
        
    ];

    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream
    constructor() { }

    subprojectNameCellRenderer(rowData: any) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup">
  </i></span>` : '';
    }

    savingsCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    }

    dateCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData: any, field: any) {
        if (rowData[field]) {
            // Any float value contains ", "we are getting issue
            const value = parseFloat(rowData[field]);
            //const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<div class="text-truncate" title="` +
                value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    subprojectStatusCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            if (rowData[field] === 'PendingCertifierAcceptance') {
                return 'Pending certifier acceptance';
            } else if (rowData[field] === 'PendingAuditorAcceptance') {
                return 'Pending auditor acceptance';
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    }


    getDefaultColumns(columns: any[] = null, role = '') {
        let col = [];
        if (!columns || columns === null) {
            return this.OrgCols;
        }
        const newColumns = _.cloneDeep(this.OrgCols);
        col = _.filter(newColumns, (v) => _.includes(columns, v.field));
        if (col.length >= 2) {
            if (columns.includes('')) {
                col[1].pinned = true;
            } else {
                col[1].pinned = false;
            }
        }
        //if (role === 'developer' || role === 'ca' || role === 'reviewer' || role === 'auditor') {
        //    if (role === 'developer') {
        //        col.find(item => item.field === 'auditorName').cellRenderer['renderHtml'] = rowData => rowData.auditorName;
        //        col.find(item => item.field === 'subprojectName').cellRenderer['renderEventBeforeHtml'] = this.notifyProjectNameCellRenderer;
        //    }
        //    else if (role === 'auditor') {
        //        col.find(item => item.field === 'subprojectName')
        //            .cellRenderer['renderEventBeforeHtml'] = this.unreadNotificationProjectNameCellRenderer;
        //    }
        //    else if (role === 'reviewer') {
        //        col.find(item => item.field === 'subprojectName')
        //            .cellRenderer['renderEventBeforeHtml'] = this.unreadNotificationProjectNameCellRenderer;
        //        col.find(item => item.field === 'auditorName').cellRenderer['renderHtml'] = rowData => rowData.auditorName;
        //    }
        //    else {
        //        col.find(item => item.field === 'auditorName').cellRenderer['renderHtml'] = this.caAuditorCellRenderer;
        //        col.find(item => item.field === 'subprojectName')
        //            .cellRenderer['renderEventBeforeHtml'] = this.unreadNotificationProjectNameCellRenderer;
        //    }
        //}
        return col;
    }
}

